export default {
  zh: {
    title: '佣金奖励的金额',
    secTitle: '你的佣金奖励金额按照下面规则获得：',
    deviceNum: '套餐设备数',
    month12: '年付',
    month3: '季付',
    month1: '月付',
    firstPopup: '首充佣金',
    renew: '续费佣金'
  },
  en: {
    title: 'The Commission Amount',
    secTitle: 'Your commission amount is counted according to the following rules:',
    deviceNum: 'Device Number',
    month12: '12 Months',
    month3: '3 Months',
    month1: '1 Month',
    firstPopup: 'First purchase commission',
    renew: 'Renewal commission'
  }
}



// WEBPACK FOOTER //
// ./src/components/affiliateProgram/commissionAmount/lang.js